import React from 'react';
import PropTypes from 'prop-types';
import { Text } from 'modules/styled';

const Triangle = ({ direction, inline, lh }) => {
  if (direction === 'UP') {
    return <Text sx={{ lineHeight: lh, color: 'green' }}>▲</Text>;
  }
  if (direction === 'DOWN') {
    return <Text sx={{ lineHeight: lh, color: 'red' }}>▼</Text>;
  }
  return null;
};

Triangle.propTypes = {
  direction: PropTypes.oneOf(['UP', 'DOWN']),
  inline: PropTypes.number,
  lh: PropTypes.number,
};

export default Triangle;
